import { Button, Dropdown, Heading, Input, Text } from "components/common";
import classes from "./AiCharactersPage.module.css";
import { useState } from "react";
import { PiSliders, PiMagnifyingGlass } from "react-icons/pi";
import Modal from "components/common/Modal/Modal";
import TabSlider from "components/common/TabSlider/TabSlider";
import Devider2 from "components/common/Devider2/Devider";
import Switch from "components/common/Switch/Switch";
import {
  smartAdvisor,
  friendlyHelper,
  techGuru,
  creativeMind,
  fitnessCoach,
} from "images";
import SingleCharacters from "./SingleCharacters/SingleCharacters";
import FilterDropdown from "./FilterDropdown/FilterDropdown";
import clsx from "clsx";

// Define Tabs and AI Models
const tabs = [
  "All",
  "Writing",
  "Programming",
  "Productivity",
  "Research",
  "Education",
];
const aiModels = ["GPT-4o", "Llama 3.2 3B", "DeepSeek R1671B", "Dolphin 72B"];

const AiCharactersPage = ({ aiCharacters }) => {
  const [searchValue, setSearchValue] = useState("");
  const [showFilterDropdown, setShowFilterDropdown] = useState(false);
  const [showSelectAiDropdown, setShowSelectAiDropdown] = useState(false);
  const [selectedAiModel, setSelectedAiModel] = useState("GPT-4o");
  const [proOnly, setProOnly] = useState(false);
  const [webEnabled, setWebEnabled] = useState(false);
  const [matureContent, setMatureContent] = useState(false);

  // Filtering AI Characters based on selected filters
  const filteredCharacters = aiCharacters.filter((character) => {
    if (proOnly && !character.isPro) return false;
    if (webEnabled && !character.webEnabled) return false;
    if (!matureContent && character.matureContent) return false;
    if (
      searchValue &&
      !character?.name.toLowerCase().includes(searchValue.toLowerCase())
    )
      return false;
    return true;
  });

  return (
    <div className={classes.pageContainer}>
      <div className={classes.heroSection}>
        <div className={classes.heroContent}>
          <Heading primitive0 large textCenter>
            Meet Your AI <span className="highlight">Companions</span>
          </Heading>
          <Text md primitive300 textCenter className={classes.heroDescription}>
            Discover a world of AI personalities, each crafted to bring unique expertise and engaging conversations to your fingertips. From creative writing to technical support, find your perfect AI match.
          </Text>
        </div>
      </div>

      <div className={classes.contentSection}>
        <div className={classes.searchAndFilter}>
          <div className={classes.searchContainer}>
            <PiMagnifyingGlass className={classes.searchIcon} />
            <Input
              sm
              value={searchValue}
              setValue={setSearchValue}
              placeholder="Find your ideal AI companion..."
              className={classes.searchInput}
            />
          </div>
        </div>

        <div className={classes.charactersGrid}>
          {filteredCharacters.length > 0 ? (
            filteredCharacters.map((character, i) => (
              <SingleCharacters {...character} key={i} />
            ))
          ) : (
            <div className={classes.noResultsContainer}>
              <Text lg className={classes.noResults} primitive0 textCenter>
                No matches found
              </Text>
              <Text sm className={classes.noResultsSubtext} primitive300 textCenter>
                Try adjusting your search to find your perfect AI companion
              </Text>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AiCharactersPage;
